<template>
  <v-dialog
    v-model="active"
    @click:outside="$emit('close')"
    width="700"
  >
    <v-card style="padding:20px 50px">
      <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
      <v-card-title class="d-flex justify-content-center" v-if="animal">
        <h4 style="color:var(--medium-blue)"> 
          <i class="mdi mdi-alert"></i>
          {{animal.name}}
        </h4> 
        <h3 class="ml-2">não possui parto</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="animal">
        <p class="text-center">Por favor lançar parto para adicioná-lo ao serviço</p>
      </v-card-text>
      <v-card-actions class="d-flex justify-content-center">
        <v-btn 
          class="buttonAdd"
          @click="redirectToBirth"
        >Gerar Parto</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:"ModalDoesntHaveBirth",
  props:{
    active:Boolean,
    animal:Object,
    service:Object
  },
  methods: {
    redirectToBirth() {
      if(this.service.id) {
        this.$router.push({name:"Birth-list", params:{animal:this.animal, service:this.service}});
      } else {
        this.$router.push({name:"Birth-list", params:{animal:this.animal}});
      }
    }
  }
}
</script>

<style scoped>
.close-icon {
  right: 10px;
  top: 10px;
  position: absolute;
  font-size: 1.3rem;
  cursor: pointer;
}
</style>
